export * from './SchoolAdminPageDetailBanner'
